export function rgbLinearChannelToHexPair(channel: number, rgbOffset: number): string {
  const hex = Math.round((channel + rgbOffset) * 255).toString(16);
  return hex.length === 1 ? '0' + hex : hex;
}

/** Shadcn-style HSL components → hex for `<input type="color">` (only consumer in this app). */
export function hslToHex(hsl: string): string {
  if (!hsl) return '#000000';
  if (isHex(hsl)) return hsl;
  const match = hsl.match(/(\d+\.?\d*)\s+(\d+\.?\d*)%\s+(\d+\.?\d*)%/);
  if (!match) return '#000000';

  const hue = parseFloat(match[1]);
  const saturation = parseFloat(match[2]) / 100;
  const lightness = parseFloat(match[3]) / 100;

  const chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  const intermediateChannel = chroma * (1 - Math.abs(((hue / 60) % 2) - 1));
  const rgbOffset = lightness - chroma / 2;

  let red = 0;
  let green = 0;
  let blue = 0;
  if (hue >= 0 && hue < 60) {
    red = chroma;
    green = intermediateChannel;
    blue = 0;
  } else if (hue >= 60 && hue < 120) {
    red = intermediateChannel;
    green = chroma;
    blue = 0;
  } else if (hue >= 120 && hue < 180) {
    red = 0;
    green = chroma;
    blue = intermediateChannel;
  } else if (hue >= 180 && hue < 240) {
    red = 0;
    green = intermediateChannel;
    blue = chroma;
  } else if (hue >= 240 && hue < 300) {
    red = intermediateChannel;
    green = 0;
    blue = chroma;
  } else if (hue >= 300 && hue < 360) {
    red = chroma;
    green = 0;
    blue = intermediateChannel;
  }

  return `#${rgbLinearChannelToHexPair(red, rgbOffset)}${rgbLinearChannelToHexPair(green, rgbOffset)}${rgbLinearChannelToHexPair(blue, rgbOffset)}`;
}

export function isHex(value: string): boolean {
  return /^#([a-f\d]{3}|[a-f\d]{6})$/i.test(value);
}

function ensureHexColor(value: string): string {
  if (isHex(value)) return value;
  return `hsl(${value})`;
}

export function toCssColor(value: string): string {
  if (!value) return '#000000';
  return ensureHexColor(value);
}
